/**
 * AuthRpcClient - AtomRpc integration for auth endpoints
 *
 * This uses AtomRpc.Tag to create a special context tag that provides
 * proper integration with the atom runtime.
 *
 * The ClerkTokenGetter layer reads the `__session` cookie directly (see
 * `readClerkSessionCookieToken`), falling back to `globalThis.__clerkSession`
 * when the cookie isn't present.
 *
 * @example
 * ```typescript
 * const userAtom = AuthRpcClient.runtime.atom((get) =>
 *   Effect.gen(function*() {
 *     const client = yield* AuthRpcClient;
 *     const user = yield* client("ensureUser", void 0);
 *     return user;
 *   })
 * );
 * ```
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AuthRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AuthRpcClient extends AtomRpc.Tag<AuthRpcClient>()(
  "AuthRpcClient",
  {
    group: AuthRpcs,
    protocol: makeRpcClientLayer(AuthRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
